import React from 'react';
import CollectionArtwork from './CollectionArtwork';
import LegendaryPatchSparkle from './LegendaryPatchSparkle';
import {PatchLevel,patchLevelColor} from '../services/patchLevels';

/** Share the displayed front and its effects without exposing concealed artwork. */
export default function PatchArtwork({id,level,aspectRatio=3/4,...artwork}:React.ComponentProps<typeof CollectionArtwork>&{id:string;level?:PatchLevel;aspectRatio?:number}){
 const image=artwork.hidden&&!artwork.earned?artwork.unearnedImage:artwork.image;
 const shimmer=!!image&&(level==='epic'||level==='legendary');
 const delay=`${-(Array.from(id).reduce((n,c)=>n+c.charCodeAt(0),0)%90)/10}s`;
 const style=shimmer?{maskImage:`url(${JSON.stringify(image)})`,WebkitMaskImage:`url(${JSON.stringify(image)})`,'--patch-shimmer-color':patchLevelColor(level),'--patch-shimmer-delay':delay} as React.CSSProperties:undefined;
 return <span className="patch-artwork" data-patch-level={level||'common'}>
  <CollectionArtwork {...artwork}/>
  {shimmer&&<span className={`patch-shimmer patch-shimmer-${level}`} style={style} aria-hidden="true"/>}
  {image&&level==='legendary'&&<LegendaryPatchSparkle image={image} delay={delay} aspectRatio={aspectRatio}/>}
 </span>;
}
